// extracted by mini-css-extract-plugin
module.exports = {"speakerIcon":"VolumeToggle_speakerIcon__h4ZcQ","nopeBar":"VolumeToggle_nopeBar__1raNX","mutedIcon":"VolumeToggle_mutedIcon__DqnET"};